<div>
  <h2 class="text-primary">{{ errorMessage.summary }}</h2>
</div>
<div>
  <h4 class="text-color-secondary">{{ errorMessage.detail }}</h4>
</div>
@if (errorMessage.recommendation) {
  <div>
    <h3 class="ui-widget">{{ errorMessage.recommendation }}</h3>
  </div>
}
<div>
  @if (errorMessage.requestId) {
    <h3 class="ui-widget">
      <span class="request-id">{{ errorMessage.requestId }}</span>
    </h3>
  }
</div>
